import { useEffect, useState } from "react"
import bscstakeAbi from '../json/bscstake.json';
import tokenAbi from '../json/token.json';
import { toast } from "react-toastify";
import { DEFAULT_CHAIN, contract } from "../helper/constant";
import { getMultiCall } from "../helper/contractHelper";
import { getWeb3 } from "../helper/connectors";
import exactMathNode from "exact-math";
import { useAccount } from "wagmi";



export const useAccountStats = (updater) => {
    let { address, isConnected } = useAccount();
    let web3 = getWeb3();


    const [stats, setStats] = useState({
        totalStaked: 0,
        totalUnStaked: 0,
        totalClaimed: 0,
        StakedCount: 0,
        tokenName: '',
        tokenSymbol: '',
        tokenDecimals: 0,
        isApproved: 0,
        stakeTokenBalance: 0,
        stakeHistory: [],
        rewardRef: 0,
        countRef: 0,
        referrer: 0,
        userReferral0: [],
        userReferral1: [],
        userReferral2: [],
        userReferral3: [],
        userReferral4: [],
        userReferral5: [],
        team0: 0,
        team1: 0,
        team2: 0,
        team3: 0,
        team4: 0,
        team5: 0
    });


    let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);

    useEffect(() => {
        const fetch = async () => {
            try {
                let stakeHistory = [];
                const data = await getMultiCall([
                    stakeContract.methods.FutureCoin(), //0
                    stakeContract.methods._stakers(address), //1
                    stakeContract.methods.getList(address), //2
                    stakeContract.methods.accounts(address), //3
                    stakeContract.methods.userReferral(address, 0), //4
                    stakeContract.methods.userReferral(address, 1), //5
                    stakeContract.methods.userReferral(address, 2), //6
                    stakeContract.methods.userReferral(address, 3), //7
                    stakeContract.methods.userReferral(address, 4), //8
                    stakeContract.methods.userReferral(address, 5), //9
                    stakeContract.methods.team(0, address), //10
                    stakeContract.methods.team(1, address), //11
                    stakeContract.methods.team(2, address), //12
                    stakeContract.methods.team(3, address), //13
                    stakeContract.methods.team(4, address), //14
                    stakeContract.methods.team(5, address), //15
                ]);





                let tokenContract = new web3.eth.Contract(tokenAbi, data[0]);

                let length = data[2][1];
                if (parseFloat(length) > 0) {
                    let getLedgerArray = [];
                    for (let i = 0; i < length; i++) {
                        getLedgerArray[i] = stakeContract.methods.getLedgerIndex(address, i);
                    }

                    stakeHistory = await getMultiCall(getLedgerArray);
                }

                const tokenData = await getMultiCall([
                    tokenContract.methods.name(),
                    tokenContract.methods.symbol(),
                    tokenContract.methods.decimals(),
                    tokenContract.methods.allowance(address, contract[DEFAULT_CHAIN].STAKE_ADDRESS),
                    tokenContract.methods.balanceOf(address)
                ]);


                let userReferral0 = data[4] ? data[4].slice(0, 9).reverse() : [];
                let userReferral1 = data[5] ? data[5].slice(0, 9).reverse() : [];
                let userReferral2 = data[6] ? data[6].slice(0, 9).reverse() : [];
                let userReferral3 = data[7] ? data[7].slice(0, 9).reverse() : [];
                let userReferral4 = data[8] ? data[8].slice(0, 9).reverse() : [];
                let userReferral5 = data[9] ? data[9].slice(0, 9).reverse() : [];




                setStats({
                    totalStaked: data[1][1] / Math.pow(10, tokenData[2]),
                    totalUnStaked: data[1][3] / Math.pow(10, tokenData[2]),
                    totalClaimed: data[1][4] / Math.pow(10, tokenData[2]),
                    StakedCount: length,
                    tokenName: tokenData[0],
                    tokenSymbol: tokenData[1],
                    tokenDecimals: tokenData[2],
                    isApproved: tokenData[3] / Math.pow(10, tokenData[2]),
                    stakeTokenBalance: tokenData[4] / Math.pow(10, tokenData[2]),
                    stakeHistory,
                    rewardRef: data[3][1] / Math.pow(10, tokenData[2]),
                    countRef: data[3][2],
                    referrer: data[3][0],
                    userReferral0,
                    userReferral1,
                    userReferral2,
                    userReferral3,
                    userReferral4,
                    userReferral5,
                    team0: data[10],
                    team1: data[11],
                    team2: data[12],
                    team3: data[13],
                    team4: data[14],
                    team5: data[15]
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }

        if (address && isConnected) {
            fetch();
        }
        else {
            setStats({
                totalAmount: 0,
                tobeRewarded: 0,
                StakedCount: 0,
                totalAmounts: 0,
                tokenName: '',
                tokenSymbol: '',
                tokenDecimals: 0,
                isApproved: 0,
                stakeTokenBalance: 0,
                stakeHistory: [],
                rewardRef: 0,
                countRef: 0,
                referrer: 0,
                userReferral0: [],
                userReferral1: [],
                userReferral2: [],
                team0: 0,
                team1: 0,
                team2: 0
            })
        }
        // eslint-disable-next-line
    }, [updater, address]);

    return stats;
}

export const useAdminStats = (updater) => {
    let { address, isConnected } = useAccount();
    let web3 = getWeb3();


    const [stats, setStats] = useState({
        FutureCoin: '',
        defaultRef: '',
        pauser: false,
        wpauser: false,
        getAmounts: [],
        owner: '',
        getAPY: '',
        minReward: 0
    });


    let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    stakeContract.methods.FutureCoin(), //0
                    stakeContract.methods.defaultRef(), //1
                    stakeContract.methods.paused(), //2
                    stakeContract.methods.wpaused(), //3
                    stakeContract.methods.getAmounts(), //4
                    stakeContract.methods.owner(), //5
                    stakeContract.methods._apy(0), //6
                    stakeContract.methods._apy(1), //7
                    stakeContract.methods._apy(2), //8
                    stakeContract.methods._apy(3), //9
                    stakeContract.methods._apy(4), //10
                    stakeContract.methods.minReward() //11


                ]);

                setStats({
                    FutureCoin: data[0],
                    defaultRef: data[1],
                    pauser: data[2],
                    wpauser: data[3],
                    getAmounts: data[4] ? data[4].map((value) => exactMathNode.div(value, Math.pow(10, 18))) : '',
                    owner: data[5],
                    minReward: data[11] / 100,
                    getAPY: `${data[6] / 100},${data[7] / 100},${data[8] / 100},${data[9] / 100},${data[10] / 100}`
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }

        if (address && isConnected) {
            fetch();
        }
        else {
            setStats({
                FutureCoin: '',
                defaultRef: '',
                pauser: false,
                wpauser: false,
                getAmounts: [],
                owner: '',
                getAPY: '',
                minReward: 0
            })
        }
        // eslint-disable-next-line
    }, [updater, address]);

    return stats;
}
